module.exports = __webpack_public_path__ + "static/img/get-gold-bc.a4978016.png";